import { useEffect, useState } from "react";

import { useGetPendingSegmentSyncQuery } from "@/pages/Private/redux/knowledgeDb/knowledgeDb.api";

import { SegmentChangeItem } from "../schema/knowledgeDbApi";

/**
 * Watches for a PENDING score-segment sync and drives the ModalSegmentSync
 * visibility state (extracted from KnowledgeDb.tsx).
 */
export const usePendingSegmentSync = (enabled: boolean) => {
	const { data: pendingSyncData } = useGetPendingSegmentSyncQuery(undefined, { skip: !enabled });

	const [showSegmentSyncModal, setShowSegmentSyncModal] = useState(false);
	const [pendingSyncChanges, setPendingSyncChanges] = useState<SegmentChangeItem[]>([]);
	const [pendingSyncId, setPendingSyncId] = useState<number | null>(null);

	useEffect(() => {
		if (pendingSyncData && pendingSyncData.length > 0) {
			const pending = pendingSyncData.find((record) => record.status === "PENDING");

			if (pending) {
				setPendingSyncChanges(pending.changeSummary.changes as SegmentChangeItem[]);
				setPendingSyncId(pending.id);
				setShowSegmentSyncModal(true);
			}
		}
	}, [pendingSyncData]);

	const closeSegmentSyncModal = () => {
		setShowSegmentSyncModal(false);
		setPendingSyncChanges([]);
		setPendingSyncId(null);
	};

	return { showSegmentSyncModal, pendingSyncChanges, pendingSyncId, closeSegmentSyncModal };
};
